// import React, {
//   useRef,
//   useState
// } from "react";

// import {
//   Button,
//   Modal,
//   ModalBody,
//   ModalFooter
// } from "@patternfly/react-core";

// import "./NewsImageGallery.css";


// const NewsImageGallery = ({
//   images = []
// }) => {
//   const modalContainerRef = useRef(null);

//   const [
//     selectedImage,
//     setSelectedImage
//   ] = useState(null);

//   if (!images.length) {
//     return null;
//   }

//   const closeModal = () => {
//     setSelectedImage(null);
//   };

//   return (
//     <div
//       ref={modalContainerRef}
//       className="news-image-gallery-container"
//     >
//       <div
//         className="news-image-gallery"
//         aria-label="Galeria zdjęć"
//       >
//         {images.map((image, index) => (
//           <button
//             key={`${image.src}-${index}`}
//             type="button"
//             className="news-image-gallery__item"
//             onClick={() => {
//               setSelectedImage(image);
//             }}
//             aria-label={`Powiększ zdjęcie ${
//               index + 1
//             } z ${images.length}`}
//           >
//             <img
//               src={image.src}
//               alt={image.alt}
//               loading="lazy"
//               className="news-image-gallery__image"
//             />

//             <span
//               className="news-image-gallery__overlay"
//               aria-hidden="true"
//             >
//               Zobacz zdjęcie
//             </span>
//           </button>
//         ))}
//       </div>

//       <Modal
//         className="news-image-gallery__modal"
//         isOpen={Boolean(selectedImage)}
//         onClose={() => {
//             setSelectedImage(null);
//         }}
//         width="fit-content"
//         maxWidth="calc(100vw - 2rem)"
//         aria-label={
//             selectedImage?.alt ||
//             "Powiększone zdjęcie"
//         }
//         >
//         <ModalBody
//             className="news-image-gallery__modal-body"
//         >
//             {selectedImage && (
//             <figure className="news-image-gallery__preview">
//                 <img
//                 src={selectedImage.src}
//                 alt={selectedImage.alt}
//                 />

//                 {selectedImage.caption && (
//                 <figcaption>
//                     {selectedImage.caption}
//                 </figcaption>
//                 )}
//             </figure>
//             )}
//         </ModalBody>
//         </Modal>
//     </div>
//   );
// };


// export default NewsImageGallery;

import React, {
  useEffect,
  useState
} from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader
} from "@patternfly/react-core";

import {
  AngleLeftIcon,
  AngleRightIcon
} from "@patternfly/react-icons";

import "./NewsImageGallery.css";


const NewsImageGallery = ({
  images = []
}) => {
  const [
    selectedImageIndex,
    setSelectedImageIndex
  ] = useState(null);

  const selectedImage =
    selectedImageIndex !== null
      ? images[selectedImageIndex]
      : null;

  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  const showPreviousImage = () => {
    setSelectedImageIndex((currentIndex) => {
      if (currentIndex === null) {
        return null;
      }

      return currentIndex <= 0
        ? images.length - 1
        : currentIndex - 1;
    });
  };

  const showNextImage = () => {
    setSelectedImageIndex((currentIndex) => {
      if (currentIndex === null) {
        return null;
      }

      return currentIndex >= images.length - 1
        ? 0
        : currentIndex + 1;
    });
  };

  /*
   * Obsługa strzałek klawiatury.
   */
  useEffect(() => {
    if (selectedImageIndex === null) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        showPreviousImage();
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        showNextImage();
      }
    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [
    selectedImageIndex,
    images.length
  ]);

  if (!images.length) {
    return null;
  }

  return (
    <div className="news-image-gallery-container">
      <div
        className="news-image-gallery"
        aria-label="Galeria zdjęć"
      >
        {images.map((image, index) => (
          <button
            key={`${image.src}-${index}`}
            type="button"
            className="news-image-gallery__item"
            onClick={() => {
              setSelectedImageIndex(index);
            }}
            aria-label={`Powiększ zdjęcie ${
              index + 1
            } z ${images.length}`}
          >
            <img
              src={image.src}
              alt={image.alt}
              loading="lazy"
              className="news-image-gallery__image"
            />

            <span
              className="news-image-gallery__overlay"
              aria-hidden="true"
            >
              Zobacz zdjęcie
            </span>
          </button>
        ))}
      </div>

      <Modal
        className="news-image-gallery__modal"
        isOpen={selectedImageIndex !== null}
        onClose={closeModal}
        width="fit-content"
        maxWidth="calc(100vw - 2rem)"
        aria-label={
          selectedImage?.alt ||
          "Powiększone zdjęcie"
        }
      >
        <ModalHeader
          className="news-image-gallery__modal-header"
        >
          <span className="news-image-gallery__sr-only">
            Podgląd zdjęcia
          </span>
        </ModalHeader>

        <ModalBody
          className="news-image-gallery__modal-body"
        >
          {selectedImage && (
            <div className="news-image-gallery__viewer">
              <figure className="news-image-gallery__preview">
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                />

                {selectedImage.caption && (
                  <figcaption>
                    {selectedImage.caption}
                  </figcaption>
                )}
              </figure>

              {images.length > 1 && (
                <>
                  <Button
                    className={[
                      "news-image-gallery__navigation",
                      "news-image-gallery__navigation--previous"
                    ].join(" ")}
                    variant="primary"
                    icon={<AngleLeftIcon />}
                    onClick={showPreviousImage}
                    aria-label="Poprzednie zdjęcie"
                  />

                  <Button
                    className={[
                      "news-image-gallery__navigation",
                      "news-image-gallery__navigation--next"
                    ].join(" ")}
                    variant="primary"
                    icon={<AngleRightIcon />}
                    onClick={showNextImage}
                    aria-label="Następne zdjęcie"
                  />
                </>
              )}
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};


export default NewsImageGallery;